import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24d937da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BaseCard" }
const _hoisted_2 = {
  class: "BaseCard__head",
  "data-testid": "head"
}
const _hoisted_3 = { class: "BaseCard__content" }
const _hoisted_4 = { class: "BaseCard__file-info" }
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  class: "BaseCard__file-details",
  "data-testid": "details"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "top", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", {
          class: "BaseCard__filename",
          title: _ctx.fileName,
          "data-testid": "name"
        }, _toDisplayString(_ctx.truncatedFileName), 9, _hoisted_5),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "details", {}, undefined, true)
        ])
      ]),
      _renderSlot(_ctx.$slots, "bottom", { dataTestid: "bottom" }, undefined, true)
    ])
  ]))
}